import { Injectable } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { TargetingSpec } from '../interfaces/targeting-spec.interface';
import { FacebookService } from '../../shared/services/facebook.service';

@Injectable()
export class TargetingApiService {

  _defaultLang = 'en_US';
  lang: string = this._defaultLang;

  adaccountId: string;

  constructor (private fbService: FacebookService,
               private translateService: TranslateService) {
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.lang = event.lang;
    });
  }

  /**
   * Set adaccount id to be used for api calls
   * @param adaccountId
   */
  setAdaccount (adaccountId) {
    this.adaccountId = adaccountId;
  }

  targetingsentencelines (targetingSpec: TargetingSpec, adaccountId = this.adaccountId) {
    return this.fbService.get({
      path: `/${adaccountId}/targetingsentencelines`,
      params: JSON.stringify({
        targeting_spec: targetingSpec,
        locale:         this.lang
      })
    }).pipe(
      map((response: any) => response.targetingsentencelines)
    );
  }

  reachestimate (targetingSpec: TargetingSpec, adaccountId = this.adaccountId, optimizeFor = 'IMPRESSIONS') {
    return this.fbService.get({
      path: `/${adaccountId}/delivery_estimate`,
      params: JSON.stringify({
        targeting_spec:    targetingSpec,
        optimization_goal: optimizeFor,
        locale:            this.lang
      })
    }).pipe(
      map((response: any) => response.data[0])
    );
  }
}
